export default __webpack_public_path__ + "static/media/Girdle of the Cloudcleaver.b8b6ada3.jpg";